import { useT } from "@magic-md/i18n/react";
import { FileText } from "lucide-react";
import { getPlatformService } from "../../platform";

export function PdfPreview({ filePath }: { filePath?: string }) {
    const t = useT("editor");
    const url = filePath ? getPlatformService().getAssetUrl?.(filePath) : undefined;

    if (!filePath || !url) {
        return (
            <div className="h-full flex flex-col items-center justify-center gap-1 text-muted-foreground">
                <FileText size={24} className="opacity-50" />
                <div className="text-[12px]">
                    {filePath ? t("preview.unsupportedPdf") : t("preview.noFilePath")}
                </div>
                {filePath && (
                    <div className="text-[10px] opacity-70">{t("preview.openInDesktop")}</div>
                )}
            </div>
        );
    }

    return (
        <iframe
            src={url}
            className="w-full h-full border-0 bg-background"
            title={filePath}
        />
    );
}
